var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"86%","width":"95%"}},[_c('div',{staticClass:"line-wrapper",staticStyle:{"marginTop":"50px"}},[_c('div',{staticClass:"line-content",attrs:{"id":_vm.id}})])])}
var staticRenderFns = []

export { render, staticRenderFns }